import fecha from 'fecha';

import locales from './locales';
import getCurrentLanguageKey from '../getCurrentLanguageKey';

import { FULL_FORMAT } from './constants';

const toDate = (str: string, fmt = FULL_FORMAT, lang?: 'es' | 'pt') => {
  fecha.i18n = locales[lang || getCurrentLanguageKey()];
  const parsedDate = fecha.parse(str, fmt);

  return parsedDate instanceof Date ? parsedDate : undefined;
};

export default toDate;
